import type { ReactNode } from "react";

export function CardFrame({
  children,
  className = "",
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className={`rounded-lg border border-border-subtle bg-card ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}
